/** Consultas de risco e bureaus (Serasa, cadastro de empresas e pessoas). */

import { httpV1 as http } from '@/services/api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function riskCompany(params) {
  return http.get('/risk/companies/info', { params });
}

export async function riskPeople(params) {
  return http.get('/risk/people/info', { params });
}

export async function serasaCompany(params) {
  return http.get(`${ALT_API_URL}/risk/companies/serasa-check`, { params });
}

export async function serasaPeople(params) {
  return http.get(`${ALT_API_URL}/risk/people/serasa-check`, { params });
}

export async function riskCheckCompany(data) {
  return http.post(`${ALT_API_URL}/risk/check-company-dispatching`, data);
}
